import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Pandabuy Spreadsheet for Beginners: Complete Starter Guide 2026',
    desc: 'New to Pandabuy Sheet? This step-by-step beginner guide walks you through everything from navigating categories to placing your first successful order.',
    slug: '/article/pandabuy-spreadsheet-for-beginners',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20desk%20workspace%20with%20notebook%20pen%20and%20laptop%20displaying%20a%20spreadsheet%20interface%20on%20screen%20warm%20natural%20morning%20light%20soft%20shadows%20clean%20minimalist%20home%20office%20aesthetic%20beginner%20friendly%20welcoming%20atmosphere&width=600&height=400&seq=article-beginners-v2&orientation=landscape',
    tag: 'Guide',
  },
  {
    title: '25 Best Pandabuy Spreadsheet Finds You Should Buy in 2026',
    desc: 'Discover the hottest Pandabuy Spreadsheet finds across sneakers, hoodies, and accessories. Handpicked products with verified seller ratings and price comparisons.',
    slug: '/article/best-pandabuy-spreadsheet-finds-2026',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20fashion%20flatlay%20with%20assorted%20trendy%20sneakers%20apparel%20and%20accessories%20arranged%20beautifully%20on%20warm%20cream%20surface%20golden%20hour%20natural%20light%20editorial%20product%20photography%20vibrant%20and%20aspirational%20lifestyle%20aesthetic&width=600&height=400&seq=article-finds-v2&orientation=landscape',
    tag: 'Trending',
  },
  {
    title: 'Pandabuy Spreadsheet Safety: Essential Tips for Secure Shopping',
    desc: 'Protect yourself while shopping online. Learn crucial safety practices, how to spot unreliable sellers, and avoid common scams when using any Pandabuy Sheet.',
    slug: '/article/pandabuy-spreadsheet-safety-tips',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20scene%20of%20a%20lock%20icon%20concept%20represented%20by%20a%20secure%20padlock%20on%20warm%20linen%20surface%20with%20soft%20natural%20lighting%20clean%20protective%20safety%20themed%20editorial%20photography%20calm%20trustworthy%20aesthetic&width=600&height=400&seq=article-safety-v2&orientation=landscape',
    tag: 'Safety',
  },
  {
    title: 'Pandabuy Sneakers Spreadsheet: Best Jordan, Nike & Yeezy Finds',
    desc: 'Dive deep into the sneakers category of the Pandabuy Spreadsheet. Find the best Jordan 4s, Dunks, Yeezys, and designer kicks from top-rated sellers.',
    slug: '/article/pandabuy-sneakers-spreadsheet',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20arrangement%20of%20premium%20sneakers%20in%20various%20colorways%20displayed%20on%20warm%20wooden%20surface%20with%20natural%20sunlight%20creating%20gentle%20shadows%20trendy%20editorial%20footwear%20photography%20aspirational%20streetwear%20aesthetic&width=600&height=400&seq=article-sneakers-v2&orientation=landscape',
    tag: 'Sneakers',
  },
  {
    title: 'Pandabuy Clothing Spreadsheet: Hoodies, Tees & Streetwear Guide',
    desc: 'Everything you need to know about the clothing categories in the Pandabuy Spreadsheet. From Essentials hoodies to Supreme tees and luxury streetwear brands.',
    slug: '/article/pandabuy-clothing-spreadsheet',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artfully%20draped%20premium%20streetwear%20pieces%20including%20oversized%20hoodies%20and%20graphic%20tees%20in%20neutral%20tones%20on%20cream%20linen%20surface%20soft%20morning%20light%20editorial%20fashion%20catalog%20aesthetic%20warm%20and%20inviting&width=600&height=400&seq=article-clothing-v2&orientation=landscape',
    tag: 'Style',
  },
  {
    title: 'Pandabuy Spreadsheet Shipping Guide: Methods, Costs & Delivery Tips',
    desc: 'Compare shipping lines, understand delivery timeframes, and discover how to save money on international shipping when ordering from your Pandabuy Sheet.',
    slug: '/article/pandabuy-spreadsheet-shipping-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shipping%20and%20logistics%20concept%20with%20cardboard%20boxes%20packing%20materials%20and%20shipping%20labels%20on%20warm%20wooden%20desk%20natural%20daylight%20clean%20organized%20workspace%20editorial%20product%20photography%20global%20delivery%20theme&width=600&height=400&seq=article-shipping-v2&orientation=landscape',
    tag: 'Shipping',
  },
  {
    title: 'Pandabuy Trusted Sellers Guide: How to Find Verified Vendors',
    desc: 'Learn our seller verification methodology and discover the most reliable vendors across all 14 categories in the Pandabuy Spreadsheet ecosystem.',
    slug: '/article/pandabuy-trusted-sellers-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trust%20and%20verification%20concept%20with%20a%20checklist%20clipboard%20and%20star%20rating%20elements%20on%20warm%20cream%20desktop%20surface%20soft%20natural%20lighting%20professional%20yet%20approachable%20editorial%20photography%20reliable%20trustworthy%20aesthetic&width=600&height=400&seq=article-sellers-v2&orientation=landscape',
    tag: 'Sellers',
  },
  {
    title: 'Best Pandabuy Budget Finds Under $30: Affordable Spreadsheet Picks',
    desc: 'Shopping on a budget? Explore the best affordable Pandabuy Spreadsheet finds — quality products under $30 across accessories, tees, and everyday essentials.',
    slug: '/article/pandabuy-budget-finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Affordable%20lifestyle%20products%20flatlay%20including%20simple%20accessories%20basic%20tees%20and%20everyday%20items%20on%20warm%20linen%20surface%20with%20soft%20natural%20light%20budget%20friendly%20clean%20aesthetic%20approachable%20welcoming&width=600&height=400&seq=article-budget-v2&orientation=landscape',
    tag: 'Budget',
  },
  {
    title: 'Pandabuy Spreadsheet QC Guide: How to Inspect Quality Photos',
    desc: 'Master the art of QC photo inspection. Learn what to look for, common red flags, and how to make confident buying decisions using Pandabuy Sheet quality checks.',
    slug: '/article/pandabuy-spreadsheet-qc-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20product%20detail%20photos%20on%20warm%20wooden%20desk%20surface%20with%20natural%20morning%20light%20quality%20inspection%20theme%20clean%20professional%20editorial%20photography%20meticulous%20detailed%20aesthetic&width=600&height=400&seq=article-qc-v2&orientation=landscape',
    tag: 'QC',
  },
];

export default function LatestArticlesSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Latest Articles</p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
              Pandabuy Sheet Guides &amp; Insights
            </h2>
            <p className="mt-4 text-sm text-foreground-500 max-w-xl mx-auto leading-relaxed">
              Expert guides, curated finds, and in-depth tutorials to help you master the Pandabuy Spreadsheet and shop with total confidence.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={article.slug}
                className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer flex flex-col"
              >
                <div className="relative h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-0.5 rounded-full bg-primary-500 text-white text-[10px] font-semibold uppercase tracking-wider">
                    {article.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-primary-600">
                    Read Article
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-[10px]"></i>
                    </span>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}